import { render, staticRenderFns } from "./MarketingObjectAdvertTab.vue?vue&type=template&id=55640938&scoped=true"
import script from "./MarketingObjectAdvertTab.vue?vue&type=script&lang=js"
export * from "./MarketingObjectAdvertTab.vue?vue&type=script&lang=js"
import style0 from "./MarketingObjectAdvertTab.vue?vue&type=style&index=0&id=55640938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55640938",
  null
  
)

export default component.exports